import React from "react";

const KindTag = ({ kind, label }) => {
  if (!kind || !label) return null;
  return (
    <span className={`nfw-tag nfw-tag-kind nfw-tag-kind-${kind}`}>{label}</span>
  );
};

export default KindTag;
